import { GraphQLFormattedError } from 'graphql';

export enum LandingPageErrorCode {
  LANDING_PAGE_SLUG_INVALID = 'LANDING_PAGE_SLUG_INVALID',
  LANDING_PAGE_SLUG_TAKEN = 'LANDING_PAGE_SLUG_TAKEN',
  LANDING_PAGE_CONFIG_INVALID = 'LANDING_PAGE_CONFIG_INVALID',
}

export function getLandingPageErrorCode(
  graphQLError: Pick<GraphQLFormattedError, 'extensions'>,
): LandingPageErrorCode | null {
  const errorType =
    typeof graphQLError.extensions?.errorType === 'string'
      ? graphQLError.extensions.errorType
      : null;
  const errorCode =
    typeof graphQLError.extensions?.code === 'string' ? graphQLError.extensions.code : null;
  const machineCode = errorType ?? errorCode;

  return Object.values(LandingPageErrorCode).includes(machineCode as LandingPageErrorCode)
    ? (machineCode as LandingPageErrorCode)
    : null;
}
